<template>
  <div class="main-layout__list main-layout__list_mxh84" v-if="list">
    <div
      class="main-layout__item main-layout__item_head main-layout__item_hover main-layout__item_p14"
    >
      <div class="w-3 t-c foz-23">
        <span>#</span>
      </div>
      <div class="w-18">
        <span>Addresse</span>
      </div>
      <div class="w-10">
        <span>Radius</span>
      </div>
      <div class="w-10">
        <span>{{ $t("listsHeader.actions") }}</span>
      </div>
    </div>

    <div
      class="main-layout__item main-layout__item_hover main-layout__item_mh"
      v-for="(office, index) in list"
      :key="office.id"
    >
      <div class="w-3 t-c">
        <span>{{ index + 1 }}.</span>
      </div>
      <div class="w-18">
        <span>{{ office.address }}</span>
      </div>
      <div class="w-10">
        <span>{{ Math.round(office.radius / 1000) }} km</span>
      </div>
      <div class="w-10 main-layout__item-actions">
        <svg
          @click="openEditOfficeModal(office)"
          width="24px"
          height="24px"
          class="main-layout__item-icon"
        >
          <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
        </svg>
        <div v-if="$guard('write', 'Offices')">
          <svg
            @click="openDeleteModal(office.id)"
            width="24px"
            height="24px"
            class="main-layout__item-icon"
          >
            <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
          </svg>
        </div>
      </div>
    </div>

    <modal
      :show="isShowDeleteModal"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeDeleteModal"
    >
      <delete-modal
        :title="$t('services.deleteTitle')"
        @cancel="closeDeleteModal"
        @next="deleteConfirm"
      />
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
    name: 'officesList',
    data() {
        return {
            offices: [
                {
                    id: 1,
                    address: 'Address 1 Kiev city 0200',
                    radius: 10,
                },
            ],
            isShowDeleteModal: false,
            deletedId: null,
        }
    },
    computed: {
        ...mapGetters({
            list: 'offices/list',
        }),
    },
    methods: {
        ...mapMutations({
            setState: 'offices/setState',
        }),
        ...mapActions({
            remove: 'offices/remove',
            fetch: 'offices/fetch',
        }),
        openDeleteModal(id) {
            this.deletedId = id
            this.isShowDeleteModal = true
        },
        closeDeleteModal() {
            this.isShowDeleteModal = false
        },
        openEditOfficeModal(office) {
            this.setState({
                key: 'office',
                data: { ...office },
            })
            this.setState({
                key: 'isShowModal',
                data: true,
            })
        },
        async deleteConfirm() {
            const isOkey = await this.remove(this.deletedId)
            if (!isOkey) return

            this.fetch()
            this.closeDeleteModal()
        },
    },
}
</script>
